import AlertCard from "./alertCard";
export default AlertCard;